import { useTranslation } from 'react-i18next';
import { ModulePlaceholderForm } from '../../components/ModulePlaceholderForm';

export default function NewOnboarding() {
  const { t } = useTranslation('panel');
  return (
    <ModulePlaceholderForm
      title="New onboarding"
      listPath="/panel/onboardings"
      tabs={[
        {
          key: 'basic',
          label: t('form.tabs.basic'),
          fields: [
            { key: 'firstName', label: 'First name', required: true },
            { key: 'lastName', label: 'Last name' },
            { key: 'email', label: 'Email', type: 'email', required: true },
            { key: 'phone', label: 'Phone', type: 'tel' },
          ],
        },
        {
          key: 'details',
          label: t('form.tabs.details'),
          fields: [
            { key: 'designation', label: 'Designation' },
            { key: 'department', label: 'Department' },
            { key: 'joiningDate', label: 'Joining date', type: 'date', required: true },
            { key: 'probationMonths', label: 'Probation (months)', type: 'number' },
          ],
        },
        {
          key: 'documents',
          label: t('form.tabs.documents'),
          fields: [
            { key: 'panUrl', label: 'PAN card URL' },
            { key: 'aadhaarUrl', label: 'Aadhaar URL' },
            { key: 'offerLetterUrl', label: 'Offer letter URL' },
          ],
        },
        { key: 'review', label: t('form.tabs.review'), fields: [] },
      ]}
    />
  );
}
